import React, { FC } from "react";
import { Link } from "react-router-dom";
import "./NotFoundPage.style.css";

export const NotFoundPage: FC = () => {
  return (
    <div className="notfound-content">
      <p>Well this sucks. I seem to have led you down a path to nowhere.</p>
      <p>
        Don't worry though, hit this <Link to="/">link</Link> and you'll be
        right back where you need to be!
      </p>
    </div>
  );
};

export default NotFoundPage;
